import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import * as CTA from '../../util/CTA';
import { Text, WYSIWYG } from '../../util/typography';
import { createMarkup } from '../../util/functions';
import * as colors from '../../util/colors';
import { H5 } from '../../util/typography/Heading';
import TertiaryButton from '../../util/CTA/TertiaryButton';
import { NAVIGATION_BREAKPOINT } from '../../constants/layout';

const Container = styled.div`
    display: flex;
    align-content: baseline; 
    flex-wrap: wrap;

    ${({type}) => type === "asco" ? `
        @media (max-width: ${NAVIGATION_BREAKPOINT}) {
            flex-direction: column;
            gap: 20px;
    }`: ``}
`;

const ImageWrapper = styled.div`   
    margin-right: 30px;
     ${({type}) => type === "asco" ? `width: 115px;`: `flex: 0 0 114px;`};
    img {
        width: 100%;
        height: 100%;
        display: block;
    }
`;

const PdfLink = styled(CTA.TertiaryButton)`
    margin-top: auto;
`;

const PdfLinkDirect = styled(TertiaryButton)`
    margin-top: auto;
`;

const InlineContent =   styled.div`
    flex: 1 1 200px;
     ${({type}) => type === "asco" ? `
        @media (max-width: ${NAVIGATION_BREAKPOINT}) {
            flex: 1 1 auto;
    }`: ``}

    a {
        &:after {
            align-self: baseline;
            margin-top: 15px;
        }
    }

    .break-text {
        display: none;

        @media(max-width: 800px) {
            display: block;
        }
    }
`;

const StyledWYSIWYG = styled(WYSIWYG)`
    a[disabled] {
        pointer-events: none;
        color: ${colors.slate};
    }
`;

const ResourceItem = ({ theme, type, label, url, image, resourceBodyText, disabled, allResourcesDisabled, isExternal=false }) => {
    const bodyTextRef = useRef(null);
    const [isHover, setIsHover] = useState(false);

    useEffect(() => {
        // For AT/screenshots: If allResourcesDisabled, disables all links within resourceBodyText
        if (resourceBodyText && allResourcesDisabled) {
            bodyTextRef.current.querySelectorAll('a').forEach(link => {
                link.setAttribute('disabled', 'true');
            });
        }
    }, [bodyTextRef.current])

     const onCardMouseEnter = () => {
        setIsHover(true);
    };

    const onCardMouseLeave = () => {
        setIsHover(false);
    };
    return (
            <Container type={type}>
                <ImageWrapper type={type}>
                    {typeof image === 'function' && image()}
                </ImageWrapper>

                <InlineContent type={type}>
                     {
                            type === "asco" ? <>
                             {resourceBodyText && 
                       
                                <H5 ref={bodyTextRef} theme={theme} dangerouslySetInnerHTML={createMarkup(resourceBodyText)} />
                            }
                            <PdfLinkDirect href={url} disabled={disabled || allResourcesDisabled} forwardedAs="span" external={isExternal} target={isExternal ? "_blank" : "_self"} parentHovered={(disabled || allResourcesDisabled) ? "none" : isHover} onMouseEnter={onCardMouseEnter} onMouseLeave={onCardMouseLeave}>
                                <Text.Button style={{ color: 'inherit' }} dangerouslySetInnerHTML={createMarkup(label)} />
                            </PdfLinkDirect>
                            </> :  <>
                            <PdfLink label={label} url={url} disabled={disabled || allResourcesDisabled} />
                             {resourceBodyText && 
                       
                                <StyledWYSIWYG ref={bodyTextRef} theme={theme} dangerouslySetInnerHTML={createMarkup(resourceBodyText)} />
                            }
                            </>
                    }
                   
                </InlineContent>
            </Container>
    );
};

export default ResourceItem;